import "./loadscreen.css";

/** Full-screen (or inline) loading indicator: two smooth counter-rotating arcs.
 *  Continuous animation, no fake percentage — it simply signals loading. */
export function LoadingScreen({ inline = false, label = "Loading" }: { inline?: boolean; label?: string }) {
  return (
    <div className={`loadscreen ${inline ? "inline" : ""}`} role="status" aria-live="polite">
      <div className="loadscreen-inner">
        <div className="loadspinner" aria-hidden="true">
          <svg width="64" height="64" viewBox="0 0 64 64">
            <circle className="track" cx="32" cy="32" r="26" fill="none" strokeWidth="5" />
            <circle className="arc-outer" cx="32" cy="32" r="26" fill="none" strokeWidth="5" />
          </svg>
          <svg width="64" height="64" viewBox="0 0 64 64">
            <circle className="arc-inner" cx="32" cy="32" r="17" fill="none" strokeWidth="4" />
          </svg>
        </div>
        <div className="loadscreen-cap">{label}<span className="loaddots"><span>.</span><span>.</span><span>.</span></span></div>
      </div>
    </div>
  );
}
